// Components - UI
import UserIcon from '@/components/ui/UserIcon/UserIcon.vue';
import PercentageCardContents from '@/components/ui/PercentageCardContents/PercentageCardContents.vue';

// Services
import ServiceProviderService from '@/services/ServiceProvidersService.js';

// Mixins
import StaggerEntranceTransition from '@/components/mixins/StaggerEntranceTransition/StaggerEntranceTransition.vue';

// EventBus
import { EventBus } from '@/EventBus.js';

export default {

  name: 'ServiceProviders',

  mixins: [
    StaggerEntranceTransition
  ],

  components: {
    UserIcon
  },

  data: function() {
    return {
      serviceProviders: [],
      searchTerm: null,
      showSearch: false
    }
  },

  created: function() {

  },

  mounted: function() {
    this.init();
  },

  beforeDestroy: function() {

  },

  methods: {
    /**
      * @private
      */
    init: function(){
      // If we are logged in as a multi-site retailer
      if(localStorage.getItem('userGroup') == 'multi-site-retailers') {
        ServiceProviderService.getAllByMultisite(localStorage.getItem('parentId')) // In this case 'parentID' is the logged in multi-site-retailer's id
          .then((res) => {
            this.serviceProviders = res.data;
          })
          .catch((err) => {
            console.log('err', err);
            alert('err, check console logs');
          });
      }
      else {
        this.loadAllServiceProviders();
      }
    },
    /**
      * @private
      */
    loadAllServiceProviders: function (){
      // Load all service providers
      ServiceProviderService.getAll(null, null, null, 'name ASC')
        .then((res) => {
          this.serviceProviders = res.data;
        });
    },

    openSearch: function() {
      this.showSearch = true;

      // Wait for element visible before focus
      setTimeout(() => {
        this.$refs.searchInput.focus();
      }, 200);
    },

    closeSearch: function() {
      this.searchTerm = null;
      this.showSearch = false;
    }
  },

  computed: {
    search: function() {
      if(this.searchTerm && this.searchTerm.trim().length > 0) {
        return this.serviceProviders.filter((s) => {
          if (s.name.toLowerCase().trim().indexOf(this.searchTerm.toLowerCase().trim()) > -1  || s.adminContactEmail.toLowerCase().trim().indexOf(this.searchTerm.toLowerCase().trim()) > -1 || s.adminContactTelephone.toLowerCase().trim().indexOf(this.searchTerm.toLowerCase().trim()) > -1) {
            return true;
          }

          return false;
        });
      }
      else {
        return this.serviceProviders;
      }
    }
  },

  watch: {
    '$route' (to, from) {
      this.init();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/ServiceProviders/ServiceProviders.js